'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _registerI18nTranslations = require('./registerI18nTranslations');

var _registerI18nTranslations2 = _interopRequireDefault(_registerI18nTranslations);

var _registerNumberFormatting = require('./registerNumberFormatting');

var _registerNumberFormatting2 = _interopRequireDefault(_registerNumberFormatting);

var _registerMoment = require('./registerMoment');

var _registerMoment2 = _interopRequireDefault(_registerMoment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Provider) {
  var validPromise = window.Q ? window.Q.Promise : Promise;
  return validPromise.all([(0, _registerI18nTranslations2.default)(Provider), (0, _registerNumberFormatting2.default)(Provider), (0, _registerMoment2.default)(Provider)]);
};

module.exports = exports['default'];